<template>
  <div id="app">
    <router-view/>
    <!-- 头部导航栏 -->
    <div class="head">
      <div style="width: 1200px;margin: 0 auto;position: relative;">
        <img class="index-head-img" @click="goIndex()" src="../src/assets/index1.png" />
        <div style="float: left;margin-left: 66px;text-align: center;margin-top: 22px;overflow: hidden;">
          <img style="width: 19px;height: 19px;float: left;margin-right: 5px;" src="../src/assets/address.png" alt="">
          <div style="font-size: 14px;float: left;">{{address}}</div>
        </div>
        <div class="index-head-div">
          <div class="index-head-divs" v-for="(item,index) in navList" :key="index" @mousemove="active = index" @mouseenter="toPage(index)" @mouseleave="toPages(index)" @click="navigationGo(index)">
            <div :class="headIndex==index?'index-head-divs-active':''">{{item.name}}</div>
          </div>
        </div>
        <div v-if="headIndex==4" class="index-head-code">
          <div class="index-head-code-triangle"></div>
          <img class="index-head-code-img1" src="../src/assets/code.png" alt="">
          <div class="index-head-code-div">华帜就业小程序</div>
        </div>
        <div class="login" v-if="isLogin==false">
<!--          :class="iscode==true?'loginActive':''"-->
          <div class="loginActive" v-if="iscodeBtn===false"  @click="getCode()">登录/注册</div>
          <div class="loginActive" v-if="iscodeBtn===true"  >登录/注册</div>
        </div>
        <el-dropdown v-if="isLogin==true" class="el-dropdowns" @command="handleMy" style="float: right;background-color:none;height: 45px;margin-top: 10px;">
          <span style="cursor:pointer;">
            <div class="logins">
              <div>您好，{{userInfo.userName}}</div>
              <img :src="userInfo.userPhoto" alt="">
            </div>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item style="width: 60px;" v-if="userInfo.identity===1&&isLogin===true||userInfo.identity===3&&isLogin===true||userInfo.identity===4&&isLogin===true||userInfo.identity===5&&isLogin===true" @click.native="binding()">企业认证</el-dropdown-item>
            <el-dropdown-item style="width: 60px;" command="4" @click.native="logout()">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div v-if="userInfo.identity===1&&isLogin===true||userInfo.identity===3&&isLogin===true||userInfo.identity===4&&isLogin===true||userInfo.identity===5&&isLogin===true" class="login-btn" @click="personalCore()">个人中心</div>
        <div v-if="userInfo.identity===2&&isLogin===true" class="login-btn" @click="EnterpriseIndex()">企业中心</div>
        <!-- 登录弹窗 -->
        <div v-if="isnotes === true">
          <div class="shade"></div>
          <img class="login-img" @click="closes()" src="../src/assets/closes.png" alt="">
          <div class="login-conts">
            <img class="login-conts-img" src="../src/assets/joblogin.png" alt="">
            <div class="login-conts-txt" style="left: 72px;">您还不是企业用户，请先企业认证</div>
            <img class="login-conts-imgs" src="../src/assets/code.png" alt="">
            <div class="login-conts-txts">使用微信扫码登录</div>
          </div>
        </div>
        <div v-if="iscode === true">
          <div class="shade"></div>
          <img class="login-img" @click="closes()" src="../src/assets/closes.png" alt="">
          <div class="login-conts">
            <img class="login-conts-img" src="../src/assets/joblogin.png" alt="">
            <div class="login-conts-txt">您还未登录,请先登录</div>
            <img class="login-conts-imgs" v-if="checkRefresh==false" :src="url" alt="" >
            <img class="login-conts-imgs cheshiclass" v-if="checkRefresh==true" :src="url" alt="" @click="getCode()">
            <div class="login-conts-txts">使用微信扫码登录</div>
          </div>
        </div>
        <!-- 登录弹窗 -->
      </div>
    </div>
    <!-- 头部导航栏 -->
    <div class="bottoms">
      <div class="bottoms-top">
        <a target="_blank" href="https://beian.miit.gov.cn/">闽ICP备2022007839号-3</a>
        <!-- <a href="www.baidu.com">ICP经营许可证：合字B2-20160007</a>
        <a href="www.baidu.com">人力资源服务许可证</a>
        <a href="www.baidu.com">营业执照</a>
        <a href="">
          <img src="https://image0.lietou-static.com/img/610bb560b2b4a8626465ef9202u.png" style="vertical-align: middle;" alt="安备">
          <span>京公网安备 11010502035189号</span>
        </a>
        <a href="www.baidu.com">个人信息保护政策</a>
        <a href="www.baidu.com">猎聘用户服务协议</a>
        <a href="www.baidu.com">投诉举报制度</a> -->
      </div>
      <div class="bottoms-botms">
        <span>Copyright © 2001-2023 fjhzrc.com All Rights Reserved</span>
        <!-- <a href="www.baidu.com">违法和不良信息举报</a> -->
      </div>
    </div>
  </div>
</template>

<script>
import request from './util/request'

export default {
  data () {
    return {
      navList: [
        { name: '首页' },
        { name: '职位推荐' },
        { name: '简历推荐' },
        { name: '资讯' },
        { name: '微信小程序' }
      ],
      url: '',
      headIndex: 0,
      headNowIndex: 0,
      num: 0,
      randKey: '',
      iscode: false,
      iscodeBtn: false,
      isLogin: false,
      userInfo: {},
      timer: null,
      timers: null,
      timerchecks: null,
      address: '福州',
      isnotes: false,
      checkRefresh: false,
      routerPath: ''
    }
  },
  watch: {
    '$route' (to, from) {
      var that = this
      this.iscode = false
      var router = this.$route.path
      that.routerPath = router
      if (this.isLogin === false) {
        // if (router === '/jobDetails') {
        //   this.timers = setInterval(() => {
        //     var token = localStorage.getItem('token')
        //     if (token !== null) {
        //       this.getUser()
        //       clearInterval(this.timers)
        //     }
        //   }, 1000)
        // } else if (router === '/enterpriseDetails') {
        //   this.timers = setInterval(() => {
        //     var token = localStorage.getItem('token')
        //     if (token !== null) {
        //       this.getUser()
        //       clearInterval(this.timers)
        //     }
        //   }, 1000)
        // } else
        if (router === '/personalCore' || router === '/jobLists') {
          var token = localStorage.getItem('token')
          if (token !== null) {
            request({
              method: 'post',
              headers: {
                'Content-Type': 'application/json; charset=utf-8',
                token: '',
                Bearer: localStorage.getItem('token')
              },
              url: `/web/user`,
              data: JSON.stringify({})
            }).then(
              (res) => {
                if (res.data.code === 200) {
                  that.userInfo = res.data.data.userInfo
                  that.isLogin = res.data.data.isLogin
                }
              },
              (err) => {
                that.$message.error(err)
              }
            )
          }
          // this.timers = setInterval(() => {
          //   var token = localStorage.getItem('token')
          //   if (token !== null) {
          //     this.getUser()
          //     clearInterval(this.timers)
          //   }
          // }, 1000)
        } else {
          clearInterval(this.timers)
        }
      }
    }
  },
  beforeCreate () {
    var that = this
    var token = localStorage.getItem('token')
    if (token !== null) {
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          if (res.data.code === 200) {
            that.userInfo = res.data.data.userInfo
            that.isLogin = res.data.data.isLogin
          }
        },
        (err) => {
          // console.log(err)
          if (err === 'token过期') {
            console.log(err)
            localStorage.removeItem('token')
          } else {
            that.$message.error(err)
          }
        }
      )
    }
  },
  created () {
    var that = this
    var router = this.$route.path
    that.routerPath = router
    if (router === '/') {
      that.headIndex = 0
      that.headNowIndex = 0
    } else if (router === '/search') {
      that.headIndex = 1
      that.headNowIndex = 1
    } else if (router === '/resumeSuggest') {
      that.headIndex = 2
      that.headNowIndex = 2
    } else if (router === '/information') {
      that.headIndex = 3
      that.headNowIndex = 3
    }
  },
  mounted () {
    var that = this
    that.$bus.on('iscode', value => {
      if (value === 'true') {
        that.getCode()
      }
    })
  },
  methods: {
    toPage (e) {
      this.headIndex = e
    },
    toPages (e) {
      this.headIndex = this.headNowIndex
      //  var that = this
      // setTimeout(function () {
      //   if (that.headIndex === 4) {
      //     that.headIndex = 0
      //   }
      // }, 5000)
    },
    navigationGo (e) {
      this.headIndex = e
      this.headNowIndex = e
      if (this.headIndex === 0) {
        if (this.routerPath !== '' && this.routerPath !== '/') {
          this.$router.push({ path: '/' })
        }
      } else if (this.headIndex === 1) {
        this.$router.push({ path: '/search' })
      } else if (this.headIndex === 2) {
        if (this.isLogin === true) {
          if (this.userInfo.identity === 2) {
            this.$router.push({ path: '/resumeSuggest' })
          } else {
            this.$message.error('您还不是企业用户，请先企业认证')
          }
        } else {
          this.isnotes = true
        }
      } else if (this.headIndex === 3) {
        this.$router.push({ path: '/information' })
      }
    },
    getCode (e) {
      const that = this
      that.iscodeBtn = true
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/qrcode/getQrCode`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.url = res.data.data.qrCode
          that.randKey = res.data.data.randKey
          that.num = 0
          that.iscode = true
          that.checkRefresh = false
          this.loginState()
          that.timerchecks = setInterval(() => {
            // this.getUser()
            this.loginState()
          }, 60000)
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    loginState () {
      var that = this
      if (that.num <= 4) {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/qrcode/check`,
          data: JSON.stringify({
            randKey: that.randKey
          })
        }).then(
          (res) => {
            var status = res.data.data.status
            if (res.data.code === 200) {
              if (status === 2) { // 过期 // 灰色
                that.checkRefresh = true
                that.url = '/static/img/refresh_btn.6f59e8a.png'
                clearInterval(that.timerchecks)
              } else if (status === 3) { // 成功
                that.num = that.num + 1
                var token = res.data.data.token
                that.iscode = false
                localStorage.setItem('token', token)
                that.$message.success('登录成功！')
                clearInterval(that.timerchecks)
                that.getUser()
              }
            }
          },
          (err) => {
            that.$message.error(err)
          }
        )
      }
    },
    handleMy (command) {
      var that = this
      switch (command) {
        case '1':
          that.logout()
          break
      }
    },
    handleCom (command) {
      var that = this
      switch (command) {
        case '1':
          that.logout()
          break
      }
    },
    closes () {
      var that = this
      that.iscode = false
      that.iscodeBtn = false
      that.isnotes = false
      clearInterval(that.timerchecks)
    },
    goIndex () {
      this.$router.push({ path: '/' })
    },
    getUser () {
      var that = this
      if (that.isLogin === false) {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/web/user`,
          data: JSON.stringify({})
        }).then(
          (res) => {
            if (res.data.code === 200) {
              if (that.timers !== null) {
                clearInterval(that.timers)
              }
              that.userInfo = res.data.data.userInfo
              that.isLogin = res.data.data.isLogin
              if (that.userInfo.identity === 2) {
                that.$router.push('/jobLists')
              }
              if (that.userInfo.identity !== 2) {
                that.$router.push('/personalCore')
              }
            }
          },
          (err) => {
            that.$message.error(err)
          }
        )
      }
    },
    personalCore () {
      this.$router.push({ path: '/personalCore' })
    },
    EnterpriseIndex () {
      this.$router.push({ path: '/jobLists' })
    },
    logout () {
      localStorage.removeItem('token')
      this.isLogin = false
      this.iscodeBtn = false
      if (this.routerPath === '' || this.routerPath === '/') {
        window.location.reload()
      } else {
        this.$router.push({ path: '/' })
      }
    },
    binding () {
      this.$router.push({ path: '/registercom' })
    }
  }
}
</script>

<style>
#app {
	position:absolute;
  top:0;
  right:0;
  bottom:0;
  left:0;
}
.head{
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #597BF6;
  color: #fff;
  /* overflow: hidden; */
  height: 64px;
  font-size: 14px;
  z-index: 997;
}
.index-head-img{
  width: 145px;
  height: 46px;
  float: left;
  margin-top: 9px;
  cursor: pointer;
}
.index-head-div{
  float: left;
  margin-left: 72px;
  overflow: hidden;
}
.index-head-divs{
  margin-right: 34px;
  float: left;
  cursor: pointer;
  font-size: 16px;
  margin-top: 22px;
}
.index-head-divs-active{
  font-weight: 700;
  border-bottom: 1px solid #fff;
  padding-bottom: 8px;
}
.index-head-div div{
  text-align: center;
}
.login{
  float: right;
  overflow: hidden;
  font-size: 14px;
}
.login div:first-child{
  float: left;
  margin-right: 15px;
  height: 31px;
  line-height: 31px;
  width: 92px;
  text-align: center;
  border-radius: 5px;
  border: 1px solid #fff;
  margin-top: 17px;
  cursor: pointer;
}
.login div:last-child{
  float: left;
  height: 31px;
  line-height: 31px;
  width: 92px;
  text-align: center;
  border-radius: 3px;
  border: 1px solid #fff;
  margin-top: 17px;
  cursor: pointer;
}
.logins{
  float: right;
  overflow: hidden;
  font-size: 14px;
}
.logins img{
  width: 45px;
  height: 45px;
  float: left;
  border-radius: 50%;
}
.logins div{
  font-size: 14px;
  color: #fff;
  float: left;
  margin-right: 12px;
  line-height: 45px;
}
.login-btn{
  float: right;
  font-size: 16px;
  margin-top: 21px;
  margin-right: 25px;
  padding-bottom: 7px;
  border-bottom: 2px solid #fff;
  cursor: pointer;
}
.index-actives{
  color: #0B0A0A;
  font-size: 16px;
  font-weight: 550;
  border-top: 2px solid #587CF7;
  box-shadow: 0 1px 8px 2px #ebebeb;
}
.headLine{
  height: 1px;
  width: 39px;
  background-color: #fff;
  margin-top: -17px;
  margin-left: 10.5px;
}
.loginActive{
  background-color: #fff;
  color: #587CF7;
}
/* 底部备案信息 */
.bottoms{
  text-align:center;
  bottom:0;
  margin:0 auto;
  width:100%;
  background-color: #fff;
  padding: 20px 0;
}
.bottoms{
  font-size: 12px;
}
.bottoms-top{
  margin-bottom: 6px;
}
.bottoms-top a{
  margin-left: 10px;
  color: #999;
  text-decoration:none
}
.bottoms-botms{
  font-size: 12px;
}
.bottoms-botms span{
  color: #999;
}
.bottoms-botms a{
  margin-left: 10px;
  color: #999;
  text-decoration:none
}
.index-head-code{
  position: absolute;
  width: 122px;
  height: 133px;
  top: 74px;
  background-color: #fff;
  text-align: center;
  left: 666px;
  border-radius: 5px;
}
.index-head-code-img1{
  width: 98px;
  height: 98px;
  margin-top: 7px;
}
.index-head-code-triangle{
  width: 0px;
  height: 0px;
  border: 10px solid transparent;
  border-bottom-color: #fff;
  margin-top: -20px;
  margin-left: 51px;
}
.index-head-code-div{
  color: #3E3E3E;
  font-size: 14px;
}
.shade{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .3);
  z-index: 998;
}
.login-img{
  position: fixed;
  z-index: 999;
  width: 25px;
  height: 25px;
  top: 170px;
  right: 0;
  margin: 0 auto;
  left: 430px;
}
.login-conts{
  position: fixed;
  z-index: 999;
  top: 200px;
  left: 0;
  width: 413px;
  height: 496px;
  right: 0;
  margin: 0 auto;
}
.login-conts-img {
  width: 100%;
  height: 100%;
}
.login-conts-imgs{
  position: absolute;
  width: 192px;
  height: 192px;
  top: 167px;
  left: 111px;
  border-radius: 15px;
}
.login-conts-txt{
  position: absolute;
  top: 110px;
  left: 122px;
  font-size: 18px;
}
.login-conts-txts{
  position: absolute;
  left: 143px;
  top: 391px;
  font-size: 16px;
  color: #8E8E8E;
}
</style>



// WEBPACK FOOTER //
// src/App.vue